import React from 'react';
import { Router, Route, Redirect } from 'react-router-dom';
import App from './components/App';
import Index from './components/Index';
import LoginForm from './components/LoginForm';
import Transports from './components/Transports';
import AuthStore from './stores/AuthStore';
import Spinner from './components/Spinner';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    AuthStore.isAuthenticated() === true
      ? <Component {...props} />
      : <Redirect to='/login' />
  )} />
)

class Root extends React.Component {
  constructor() {
    super();
    this.state = {
      authenticated: AuthStore.isAuthenticated()
    }
    this.onChange = this.onChange.bind(this);
  }

  componentWillMount() {
    AuthStore.addChangeListener(this.onChange);
  }

  componentWillUnmount() {
    AuthStore.removeChangeListener(this.onChange);
  }

  onChange() {
    if (AuthStore.isAuthenticated()){
      this.props.history.push('/');
    } else {
      this.props.history.push('/login');
    }
    this.setState({
      authenticated: AuthStore.isAuthenticated()
    });
  }

  render() {
    return (
      <Router history={this.props.history}>
        <App>
          <Spinner/>
          <Route path="/login" component={LoginForm}/>
          <PrivateRoute exact={true} path="/" component={Index}/>
          <PrivateRoute path='/month/:month/:year' component={Transports} />
        </App>
      </Router>
    );
  }
}

export default Root;



// WEBPACK FOOTER //
// ./src/Root.js